import {AfterViewInit, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {ApiUrl} from "../../../shared/models/apiurl.models";
import {LoadingMaskServiceService} from "../../../components/loading-frame/loading-frame.component";
import {Observable, Subject, throwError} from "rxjs";
import {catchError, filter, map, takeUntil} from "rxjs/operators";
import {FilterBase} from "../../../models/filter-base";
import {FilterbaseService} from "./filter-base/services/filterbase.service";
import {selectOptionData} from "../../create-adv/dynamic-form-question/dynamic-form-question.component";
import {ActivatedRoute, Router} from '@angular/router';


@Component({
    selector: 'app-top-filter',
    templateUrl: './top-filter.component.html',
    styleUrls: ['./top-filter.component.css'],
    standalone: false
})
export class TopFilterComponent implements OnInit, AfterViewInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();

  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.apiKey.getJWTToken()
    })
  }

  @Output()
  callBackFunction = new EventEmitter<string>();
  advancedSearch: boolean = false;
  _filterBoxWitdh: any;



  getRequiredClass(filterBase: FilterBase):string{
    if(filterBase.widthRate != null){
      return filterBase.widthRate;
    }
    return '';
  }
  constructor(private http: HttpClient, private apiKey:ApiUrl, private loadingMaskServiceService: LoadingMaskServiceService,public filterBaseService: FilterbaseService, private elementRef: ElementRef, private apiUrl: ApiUrl, private route: ActivatedRoute, private router: Router) {
    // The filters must belong to THIS page before anything reads them.
    this.filterBaseService.ensureScope();
    this.restoreFiltersFromUrl();
    this.loadData();
    this.filterBaseService.getClickEvent().pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.initBindSelect();
      this.syncFiltersToUrl();
    })
  }

  get activeFilters(): Array<{key: string; label: string; value: string}> {
    return this.filterBaseService.getActiveQuestions().map(({key, value}) => ({
      key,
      label: this.filterBaseService.filterBases.find(filter => filter.key === key)?.label || key,
      value: this.formatFilterValue(value)
    })).filter(filter => !!filter.value);
  }

  removeFilter(key: string): void {
    this.filterBaseService.sendRemoveEvent(key);
    this.filterBaseService.deleteQuestion(key);
  }

  clearAllFilters(): void {
    this.filterBaseService.clearAllQuestions();
  }

  private formatFilterValue(value: any): string {
    if (value === true) return 'כן';
    if (Array.isArray(value)) return value.map(item => item?.label || item?.value?.name || item).join(', ');
    if (value && value.range) {
      const from = value.from?.label || value.from?.value?.name || value.from || '';
      const to = value.to?.label || value.to?.value?.name || value.to || '';
      return [from && `מ־${from}`, to && `עד ${to}`].filter(Boolean).join(' ');
    }
    if (value && typeof value === 'object') return value.label || value.value?.name || value.value?.value || '';
    return String(value || '');
  }

  private restoreFiltersFromUrl(): void {
    const encoded = this.route.snapshot.queryParamMap.get('filters');
    if (!encoded) return;
    try { this.filterBaseService.replaceQuestions(JSON.parse(encoded)); }
    catch { /* Ignore malformed shared URLs. */ }
  }

  private syncFiltersToUrl(): void {
    const questions = Object.fromEntries(this.filterBaseService.getActiveQuestions().map(item => [item.key, item.value]));
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {filters: Object.keys(questions).length ? JSON.stringify(questions) : null},
      queryParamsHandling: 'merge',
      replaceUrl: true
    });
  }

  initBindSelect() {
    this.filterBaseService.filterBases.filter(ques => ques.type === "bindSelect").forEach(qs => {
      const quesParam = this.apiUrl.pathTranslate(qs.callBackFunction, this.filterBaseService);
      let isDisplay = true;
      quesParam.requiredField.forEach(res => {
        if (res.value != '' && res.value != null) {
          isDisplay = false;
        }
      })
      if (!isDisplay) {
        this.http.get<selectOptionData[]>(quesParam.path).subscribe((res: selectOptionData[]) => {
              if (res != null && res.length > 0) {
                qs.bindSelectHide = !isDisplay;
              } else {
                qs.bindSelectHide = isDisplay;
              }
            }
        )
      }else{
        qs.bindSelectHide = !isDisplay;
      }
    })
  }

  ngOnInit(): void {

  }

  loadData(): void{
    this.loadingMaskServiceService.setOnLoadingMask(true, true);
    this.getFilterBase().subscribe((res)=>{
      this.filterBaseService.filterBases = res.sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
      this.loadingMaskServiceService.setOnLoadingMask(false, false);
    },()=>{
      this.loadingMaskServiceService.setOnLoadingMask(false, false);
    })
  }

  private handleObserverError(error: any): Observable<any>{
    this.loadingMaskServiceService.setOnLoadingMask(false, false);
    return throwError(error.error || error)
  }

  getFilterBase(): Observable<any>{
    const namespance = this.apiKey.getNameSpacePos("/",3);
    const sub_category = this.apiKey.getNameSpacePos("/",5);
    return this.http.get(this.apiKey.getFilterBase(namespance, sub_category), this.options)
      .pipe(map((res) => res ? res : null ),catchError(this.handleObserverError)
      );
  }

  openAdvancedSearch() {
    if(this.advancedSearch){
      this.advancedSearch = false;
    }else{
      this.advancedSearch = true;
    }
  }

  searchApply() {
    this.callBackFunction.emit()
  }

  set filterBoxWidth(width: number){
    this._filterBoxWitdh = width;
  }
  get filterBoxWidth(){
    return this._filterBoxWitdh;
  }
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit(): void {
    const componentWidth = this.elementRef.nativeElement.offsetWidth;
    this.filterBoxWidth = componentWidth;
  }
}
